import { useEffect } from "react";
import { useLang } from "../i18n";

const OG_IMAGE = "https://images.unsplash.com/photo-1474674556023-efef886fa147?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=80";
const LOCALE = { sk: "sk_SK", en: "en_GB", de: "de_DE" };

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = () => {
  const { lang, t } = useLang();

  useEffect(() => {
    const url = window.location.origin + "/";
    document.documentElement.lang = lang;
    document.title = t("seo_title");
    setMeta("name", "description", t("seo_desc"));
    setMeta("name", "keywords", t("seo_keywords"));
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "ZTS F-Invest s.r.o.");
    setMeta("property", "og:title", t("seo_title"));
    setMeta("property", "og:description", t("seo_desc"));
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", LOCALE[lang]);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", t("seo_title"));
    setMeta("name", "twitter:description", t("seo_desc"));
    setMeta("name", "twitter:image", OG_IMAGE);

    let ld = document.getElementById("ld-json");
    if (!ld) {
      ld = document.createElement("script");
      ld.id = "ld-json";
      ld.type = "application/ld+json";
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "RealEstateAgent",
      name: "ZTS F-Invest s.r.o.",
      description: t("seo_desc"),
      url,
      image: OG_IMAGE,
      telephone: "+421905207101",
      email: "ztsfinvest@ztsfinvest.sk",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Areál ZTS č. 924, P.O. BOX 34",
        addressLocality: "Dubnica nad Váhom",
        postalCode: "018 41",
        addressCountry: "SK",
      },
    });
  }, [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
